import { Button } from "@nimit9/signet-ui/components/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@nimit9/signet-ui/components/dropdown-menu"
import { useEffect, useState } from "react"

interface DevUser {
  id: string
  name: string
  email: string
  household: string
}

const DEV_PASSWORD = (import.meta.env.VITE_DEV_AUTH_PASSWORD as string) || "devpassword123"

export function DevUserSwitcher() {
  const [users, setUsers] = useState<DevUser[]>([])
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!import.meta.env.DEV) return
    fetch("/api/dev-auth/users")
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d?.data && setUsers(d.data))
      .catch(() => {})
  }, [])

  if (!import.meta.env.DEV || users.length === 0) return null

  const switchTo = async (user: DevUser) => {
    setBusy(true)
    setError(null)
    try {
      // Sign out first so the new session replaces the current one cleanly.
      await fetch("/api/auth/sign-out", { method: "POST", credentials: "include" })
      const res = await fetch("/api/auth/sign-in/email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email: user.email, password: DEV_PASSWORD }),
      })
      if (!res.ok) {
        // Surface the failure — we may now be signed out, so make that visible.
        const body = (await res.json().catch(() => null)) as { message?: string } | null
        setError(body?.message || `Switch failed (${res.status}) — you may be signed out`)
        setBusy(false)
        return
      }
      window.location.href = "/"
    } catch {
      setError("Switch request failed — you may be signed out")
      setBusy(false)
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          disabled={busy}
          className="w-full justify-start text-text-muted"
        >
          Switch dev user
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        <DropdownMenuLabel>Sign in as…</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {users.map((u) => (
          <DropdownMenuItem key={u.id} onClick={() => switchTo(u)}>
            {u.name}
            <span className="ml-auto text-[11px] text-text-muted">{u.household}</span>
          </DropdownMenuItem>
        ))}
        {error && <p className="px-2 py-1 text-[11px] text-accent-red">{error}</p>}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
